import DittoHeader from '@/components/headers/DittoHeader.vue'
import PublicHeader from '@/components/headers/PublicHeader.vue'
import establishment from '@/router/establishment'
import individual from '@/router/individual'
import services from '@/router/services'
import authedUserCommonRoutes from '@/router/auth_user.js'
import typingCenter from '@/router/typing_center.js'
import { useAuthStore } from '@/stores/auth'
import ForgotPassword from '@/views/auth/ForgotPassword.vue'
import Logout from '@/views/auth/Logout.vue'
import ValidatepassView from '@/views/auth/ValidatepassView.vue'
import EstablishmentInquiry from '@/views/establishment-inquiry/index.vue'
import ChangeUsername from '@/views/establishments/ChangeUsername.vue'
import RegisterEstablishments from '@/views/establishments/register.vue'
import FileValidityView from '@/views/file-validity/index.vue'
import GatewayCallback from '@/views/pg-callback/index.vue'
import ChangeUsernameVue from '@/views/typing-centers/ChangeUsername.vue'
import RegisterTypingCenters from '@/views/typing-centers/register.vue'
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/home/index.vue'
import RedirectorView from '@/views/RedirectorView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        breadcrumb: 'Home'
      },
      components: {
        default: HomeView,
        navbar: PublicHeader
      }
    },
    {
      path: '/auth/pass',
      name: 'ValidateUAEPass',
      components: { default: ValidatepassView }
    },

    {
      path: '/redirector',
      name: 'AuthRedirector',
      component: RedirectorView
    },

    ...services,
    ...individual,
    ...establishment,
    ...typingCenter,
    ...authedUserCommonRoutes,

    // {
    //   path: '/application-tracking',
    //   name: 'ApplicationTracking',
    //   components: {
    //     default: ApplicationTrackingView,
    //     navbar: DittoHeader
    //   }
    // },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      components: {
        default: ForgotPassword,
        navbar: PublicHeader
      }
    },
    {
      path: '/establishments/registration',
      name: 'RegisterEstablishments',
      components: {
        default: RegisterEstablishments,
        navbar: PublicHeader
      }
    },
    {
      path: '/typing-centers/registration',
      name: 'RegisterTypingCenters',
      components: {
        default: RegisterTypingCenters,
        navbar: PublicHeader
      }
    },
    {
      path: '/establishments/change-username',
      name: 'EstablishmentChangeUsername',
      meta: {
        breadcrumb: {
          label: 'ChangeUsername'
        }
      },
      components: {
        default: ChangeUsername,
        navbar: PublicHeader
      }
    },
    {
      path: '/typing-centers/change-username',
      name: 'TypingcentersChangeUsername',
      meta: {
        breadcrumb: {
          label: 'TypingcentersChangeUsername'
        }
      },
      components: {
        default: ChangeUsernameVue,
        navbar: PublicHeader
      }
    },

    {
      path: '/customer-survey',
      name: 'CustomersurveyView',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/ComingsoonView.vue')
      }
    },
    {
      path: '/faq',
      name: 'FAQView',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/faq/index.vue')
      }
    },
    {
      path: '/instructions',
      name: 'InstructionsView',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/instructions/index.vue')
      }
    },
    {
      path: '/help/browse-services',
      name: 'BrowseServicesHelpView',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/browse-services/help/index.vue')
      }
    },
    {
      path: '/browse-services',
      name: 'BrowseServicesMainView',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/ComingsoonView.vue')
        // default: () => import('@/views/browse-services/main/index.vue')
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/AboutView.vue')
      }
    },
    {
      path: '/establishment-inquiry',
      name: 'EstablishmentInquiry',
      components: {
        navbar: PublicHeader,
        default: EstablishmentInquiry
      }
    },
    {
      path: '/file-validity',
      name: 'FileValidity',
      components: {
        navbar: PublicHeader,
        default: FileValidityView
      }
    },
    {
      path: '/colors',
      name: 'ColorPalette',
      components: {
        navbar: PublicHeader,
        default: () => import('@/views/ColorsView.vue')
      }
    },
    {
      path: '/pg-callback',
      name: 'GatewayCallback',
      components: {
        navbar: DittoHeader,
        default: GatewayCallback
      }
    }
  ],
  scrollBehavior() {
    return { top: 0 }
  }
})

export const userTypeLandings = {
  1: 'IndLanding',
  5: 'IndLanding',
  6: 'IndLanding',
  7: 'IndLanding',
  8: 'IndLanding',
  3: 'EstDashboard',
  10: 'EstDashboard',
  13: 'IndLanding',
  2: 'TCDashboard'
}

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  if (to.meta.needsAuth && !authStore.isLoggedIn) {
    return next({ name: 'home' })
  }

  const publicRouteNames = ['home', 'ServicesRoot']

  /**
   * if an authenticated user goes to the root url
   * redirect them to the user type dashboard
   */
  if (authStore.isLoggedIn) {
    const {
      user: { applicationId }
    } = authStore

    /**
     * if user is going to one of the public routes,
     * they shouldn't be redirected to that. instead take them to their
     * respective dashboard
     */
    if (publicRouteNames.includes(to.name)) {
      if (
        Object.keys(userTypeLandings)
          .map((i) => +i)
          .includes(+applicationId)
      ) {
        return next({ name: 'AuthRedirector' })
        // return next({ name: userTypeLandings[applicationId] })
      }
    }
  }

  return next()
})

export default router
